import React from "react";
import { Button } from "mesh-component-library";
import { TRANSLATION_CONSTANTS } from "../../app-consts/translations";
import { useLocale } from "../../contexts/LocaleContext";
import { callCustomerServicePhone } from "../../utilities/PhoneUtils";

export type HelpContinueProps = {
  chatEnabled: boolean;
  contactUsEnabled?: boolean;
  btnText?: string;
  content: string;
  handleClick?: () => void;
  header: string;
  logChatIntakeResults: (payload: string) => void;
  openChatbot: () => void;
  partnerPhone?: string;
};

export const HelpContinue = ({
  btnText,
  chatEnabled,
  content,
  handleClick,
  header,
  logChatIntakeResults,
  openChatbot,
  partnerPhone,
  contactUsEnabled = false,
}: HelpContinueProps) => {
  const getTranslatedText = useLocale();

  const handleOpenChat = () => {
    logChatIntakeResults("Chat button clicked from Help Stuck page");
    openChatbot();
  }

  const handleContactUsClick = () => {
    if (chatEnabled) {
      handleOpenChat();
    } else {
      handlePhoneCall();
    }
  };

  const handlePhoneCall = () => {
    callCustomerServicePhone(partnerPhone, "HelpContinue");
  };

  const contactUsText = chatEnabled
    ? getTranslatedText(TRANSLATION_CONSTANTS.CHAT_FOR_HELP)
    : getTranslatedText(TRANSLATION_CONSTANTS.CALL_HELP_NOW);

  return (
    <div className="help-container l-container-home">
      <div className="help-content">
        <h1 className="l-container-home__hd u-vr-3 u-vr-3-top u-hr-2 u-hr-2-left">{header}</h1>
        <p> {content} </p>
        {contactUsEnabled === true ? (
          <Button
            size="lg"
            hasUpgrade
            tabIndex={0}
            id="call-for-help-now"
            onClick={handleContactUsClick}
            onKeyDown={handleContactUsClick}
          >
            {contactUsText}
          </Button>
        ) : (
          <Button size="lg" hasUpgrade tabIndex={0} id="call-for-help-now" onClick={handleClick}>
            {btnText}
          </Button>
        )}
      </div>
    </div>
  );
};
